export default function DashboardIcon () {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_700" data-name="Rectangle 700" width="12.11" height="12.11" fill="none"/>
        </clipPath>
      </defs>
      <rect id="Rectangle_701" data-name="Rectangle 701" width="37" height="37" rx="18.5" opacity="0"/>
      <g id="Group_1948" data-name="Group 1948" transform="translate(13.998 10.891)">
        <g id="Group_1947" data-name="Group 1947" clipPath="url(#clip-path)">
          <path id="Path_1242" data-name="Path 1242" d="M11.964,1.141,6.52,8.264A3.287,3.287,0,1,1,3.761,5.579L10.972.143a.71.71,0,0,1,.992,1" transform="translate(0 0)" fill="currentColor"/>
        </g>
      </g>
    </svg>
  );
}